import React from 'react';
import PathologyResearchesTable from './Components/PathologyResearchesTable';

const PathologyResearchesPage = () => {
  return (
    <div className="w-full h-full">
      <div className="pb-1">
        <PathologyResearchesTable />
      </div>
    </div>
  );
};

export default PathologyResearchesPage;
